import { Members as MembersComponent } from '../../components/About/index'

export const Members = () => {
    return <MembersComponent full={true} />
}
